import { watch } from "vue";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
  name: "CustomReviewsSelect",
  props: {
    error: {
      type: String,
      require: false
    },
    placeholder: {
      type: String,
      require: true,
    },
    label: {
      type: String,
      require: false,
      default: ""
    },
    list: {
      type: Array,
      require: false,
      default: () => []
    },
    scriptSearch: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  components: {
    VueSlideToggle
  },
  data() {
    return {
      open: false,
      searchText: "",
      showList: null
    }
  },
  watch: {
    list: {
      handler() {
        this.showList = this.list;
      },
      deep: true
    }
  },
  created() {
    this.showList = this.list;
  },
  methods: {
    handleSearch(text) {
      if (!this.scriptSearch) {
        console.log(text, "search");
        this.$emit("search", text);
        return;
      }
      if (text.length > 2) {
        this.showList = this.list.filter(item => item.title.toLowerCase().includes(text.toLowerCase()));
      } else {
        this.showList = this.list;
      }
    },
    handleSelect(value) {
      this.searchText = value.title;
      this.$emit("select", value);
      this.open = false;
    },
    handleInputFocus() {
      this.open = true;
    },
    handleInputFocusOut() {
      setTimeout(() => {
        this.open = false;
      }, 200);
    }
  }
}
